import { Card, Modal, ModalCloseButton, Section, WhatsappButton } from '@presentation/components';
import { useRouter } from '@application/utils';
import { TbArrowRight } from 'react-icons/tb';
import { useMemo } from 'react';
import type { FC } from 'react';
import type { WhatsappModalProps } from './types';
import { ProHeader } from './components/ProHeader';
import { WhatsappForm } from './components/WhatsappForm';
import { BreederHeader } from './components/BreederHeader';

export * from './types';

export const WhatsappModal: FC<WhatsappModalProps> = (props) => {
  const { modal, onConfirm, pro, breeder } = props;

  const { translate } = useRouter();

  const buttonLabel = translate('common.modals.whatsApp.cta');

  const isPro = useMemo(() => {
    return !!pro;
  }, [pro]);

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />

        {isPro ? <ProHeader pro={pro} /> : <BreederHeader breeder={breeder} />}
        <WhatsappForm breeder={breeder} />

        <Section centerChildren>
          <WhatsappButton
            onClick={onConfirm}
            color="whatsappGreen"
            iconRight={<TbArrowRight />}
            label={buttonLabel}
            shrink
            outlined
          />
        </Section>
      </Card>
    </Modal>
  );
};
